module.exports = __webpack_public_path__ + "img/stripe-logo-blue.fb4644a0.png";